import React, { useState, useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';


const EstilosBotonPDF = styled('div')({
    
});

export function BotonPDF({ children, className }) {
    return (
        <EstilosBotonPDF className={className}>
            {children}
        </EstilosBotonPDF>
    );
}